/* eslint-disable */
import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import { PageHeader, Button, Row, Col, DatePicker, Input, Card } from 'antd'
// import SelectUser from '../../../components/Ants/Select/SelectUser'
import TableSender from '../../../components/Ants/Table/TableSender'
import { getAccId, token, CheckTokenExp, ReplaceUrlTaga, getUserIdname, getUsername, getId } from '../../../config'
import moment from 'moment'
import 'moment-timezone'
import { apiClient } from '../../../api'
// import ModalSuccess from '../../../components/Ants/Modal/ModalSuccess'
// import ModalWarning from '../../../components/Ants/Modal/ModalWarning'
import SelectSenderAccount from '../../../components/Ants/Select/SelectSenderAccount'

moment.tz.setDefault("Asia/Bangkok")

// const dateFormat = 'DD/MM/YYYY'
// const { MonthPicker, RangePicker, WeekPicker, } = DatePicker

export default class List extends Component {
    constructor(props) {
        super(props)
        this.state = {
            warningModalVisible: false,
            successModalVisible: false,
            loading: false,
            message: "",
            messageSuccess: "",
            name: "",
            search: {
                name: "",
                account: [],
            },
            page: "",
            templateItem: [],
            action: "",
            screenwidth: 0,
            account: [],
            haslimitSender: true,
            isRequestSender: false,
            isEcomLimit: false
        }

        this.warningModal = this.warningModal.bind(this)
        this.successModal = this.successModal.bind(this)
        this.modalcountDown = this.modalcountDown.bind(this)
        this.setStateByProps = this.setStateByProps.bind(this)
        this.onSearch = this.onSearch.bind(this)
        this.updateWindowDimensions = this.updateWindowDimensions.bind(this)
        this.setStateByProps = this.setStateByProps.bind(this)
        this.handleKeyDown = this.handleKeyDown.bind(this)
        this.onChangeAccount = this.onChangeAccount.bind(this)
        this.limitSender = this.limitSender.bind(this)
        this.Getpermission = this.Getpermission.bind(this);
    }

    componentDidMount() {
        this.Getpermission();
        this.updateWindowDimensions()
        this.limitSender()
        window.addEventListener("resize", this.updateWindowDimensions.bind(this))
        ReplaceUrlTaga()
    }

    componentWillUnmount() {
        window.removeEventListener("resize", this.updateWindowDimensions.bind(this))
    }

    updateWindowDimensions() {
        setTimeout(() => {
            var root = document.getElementById("root")
            if (root) {
                var e = document.getElementById("main")
                if (e) {
                    var scroll = root.offsetHeight > window.innerHeight
                    this.setState({ screenwidth: scroll ? e.offsetWidth - 120 : e.offsetWidth - 116 })
                }
            }
        }, 500)
    }

    Getpermission() {
        if (!CheckTokenExp()) {
            this.setState({ loading: true });
            let req = JSON.stringify({});
            apiClient.post('api/usersmanage/Getpermission', req
                , {
                    headers: {
                        'Authorization': `Bearer ${token}`,
                        'Content-type': 'application/json; charset=UTF-8'
                    }
                })
                .then(data => {
                    var json = data.data;
                    this.setState({
                        isRequestSender: json.isRequestSender,
                        isEcomLimit: json.isEcomLimit
                    });
                    this.setState({ loading: false });
                })
                .catch(error => {
                    this.setState({
                        isRequestSender: false,
                        isEcomLimit: false
                    });
                    this.setState({ loading: false });
                });
        } else {
            window.location.href = "logout";
        }
    }

    warningModal(value, message, messageSuccess) {
        this.setState({ warningModalVisible: value, message, messageSuccess })
    }

    successModal(value) {
        this.setState({ successModalVisible: value })

        let modalcontent = document.querySelectorAll('.ant-modal-contentant-modal-content-hide')
        for (var i = 0; i < modalcontent.length; i++) {
            modalcontent[i].className = "ant-modal-content"
        }
    }

    modalcountDown() {
        let secondsToGo = 2
        const timer = setInterval(() => {
        }, 1000)
        setTimeout(() => {
            clearInterval(timer)
            this.setState({ successModalVisible: false })
        }, secondsToGo * 1000)


    }

    onSearch() {
        this.setState(state => {
            return {
                search: {
                    name: state.name,
                    account: state.account,
                }
            }
        })
        this.updateWindowDimensions()
    }

    setStateByProps(parameters, value) {
        value ? value : ""
        this.setState({ [parameters]: value })

    }

    handleKeyDown(e) {
        if (e.key === 'Enter') this.onSearch()
    }

    onChangeAccount() {
        this.onSearch()
    }

    limitSender() {
        if (!CheckTokenExp()) {
            this.setState({ loading: true });

            let req = JSON.stringify({
                "accLogin": parseInt(getAccId()),
            });

            apiClient.post('api/sender/limitSender', req
                , {
                    headers: {
                        'Authorization': `Bearer ${token}`,
                        'Content-type': 'application/json; charset=UTF-8'
                    }
                })
                .then(data => {
                    var json = data.data;

                    if (json.statusCode == "200") {
                        this.setState({ haslimitSender: false });
                    }
                    this.setState({ loading: false });
                })
                .catch(error => {
                    this.setState({ loading: false });
                });
        } else {
            window.location.href = "logout";
        }
    }

    render() {
        const { search, templateItem, action, account, haslimitSender, isRequestSender } = this.state

        const routes = [
            {
                path: 'communication',
                breadcrumbName: 'Communication',
            },
            {
                path: 'sender/list',
                breadcrumbName: 'Sender List',
            },
        ]
        var styleinput_name = {
            // width: (screenwidth),
            marginRight: 8,
            marginBottom: 8,
            minWidth: 200
        }

        return (
            <div className="animated fadeIn">
                <PageHeader breadcrumb={{ routes }} style={{ minHight: "65px" }}>
                    {isRequestSender && (
                        <Row gutter={8} type="flex" justify="end">
                            <Col xs={12} sm={12} md={12} lg={12} xl={12}>
                                <div style={{ textAlign: "right" }}>
                                    <Link to={"/communication/sender/requestSender"}>
                                        <Button type="primary" style={{ marginRight: 8 }} disabled={haslimitSender}>
                                            Request Sender Name
                                        </Button>
                                    </Link>
                                </div>
                            </Col>
                        </Row>
                    )}
                </PageHeader>

                <div className="content">
                    <Card>
                        <Row gutter={8} className="row-nowrap" id="main">
                            <Col xs={10}>
                                <Input placeholder="Sender name" style={styleinput_name} onChange={(e) => this.setStateByProps("name", e.target.value)} onKeyDown={this.handleKeyDown} />
                            </Col>
                            <Col xs={10}>
                                <SelectSenderAccount
                                    placeholder={"Select Account"}
                                    account={account}
                                    select={account}
                                    setStateByProps={this.setStateByProps}
                                    onChange={this.onChangeAccount} />
                            </Col>
                            <Col xs={4}>
                                <Button icon="search" onClick={this.onSearch}>
                                    Search
                                </Button>
                            </Col>
                        </Row>
                        <Row gutter={8} type="flex" justify="center">
                            <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                                <TableSender
                                    search={search}
                                    templateItem={templateItem}
                                    action={action}
                                    warningModal={this.warningModal}
                                    setStateByProps={this.setStateByProps}
                                    updateWindowDimensions={this.updateWindowDimensions}
                                />
                            </Col>
                        </Row>
                    </Card>
                </div>
            </div>
        )
    }
}


